import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { bool, string } from 'prop-types';

import ReducedLogo from 'components/common/Brand/ReducedLogo';
import Tag from 'components/common/Tag/Tag';

const OriginalTag = ({ withBackground, className }) => {
  const intl = useIntl();

  return (
    <div className={cn('original', { full: withBackground }, className)}>
      <ReducedLogo isTransparent={withBackground} />
      <Tag
        label={intl.formatMessage({ id: 'content.original' })}
        className="original-tag"
        centeredContent
        isTransparent
      />
    </div>
  );
};

OriginalTag.propTypes = {
  withBackground: bool,
  className: string
};

export default OriginalTag;
